import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import { IconReviewStar } from '../../components';

import css from './ListingRating.module.css';

/**
 * Displays a compact star rating with review count.
 * Rating is stored as integer (e.g. 45 = 4.5 stars) in listing metadata.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {number} props.rating - integer rating (0-50, where 50 = 5.0 stars)
 * @param {number} props.numReviews - number of reviews
 */
const ListingRating = ({ className, rating, numReviews }) => {
  const intl = useIntl();

  if (!rating || !numReviews) {
    return null;
  }

  const formattedRating = (rating / 10).toFixed(1);
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <IconReviewStar className={css.star} isFilled />
      <span className={css.text}>
        {intl.formatMessage(
          { id: 'ListingRating.rating' },
          { rating: formattedRating, numReviews }
        )}
      </span>
    </div>
  );
};

export default ListingRating;
